import {
  ENDPOINT_GET_LOAN_APPLICATIONS,
  ENDPOINT_GET_LOAN_OFFERS,
  ENDPOINT_IFP_GET_APPLICATIONS,
} from '@shared/sec-loans'
import { GetDataStep } from '@ui-common/steps/GetDataStep/GetDataStep'
import { callEndpoint } from '@ui-common/utils/http/client'
import { JSX } from 'react'
import { useIntl } from 'react-intl'
import { AnyActorRef } from 'xstate'

import { ApplicationsMetaData } from '../../types'

export const GetAllApplicationsStep = (props: { parentService: AnyActorRef; onAbort: () => unknown }): JSX.Element => {
  const intl = useIntl()

  const { parentService } = props

  return (
    <GetDataStep
      parentService={parentService}
      getDataCallback={async () => {
        const [ifpApplicationsMetadata, loanApplicationsMetadata, loanOffersMetadata] = await Promise.all([
          callEndpoint(ENDPOINT_IFP_GET_APPLICATIONS),
          callEndpoint(ENDPOINT_GET_LOAN_APPLICATIONS),
          callEndpoint(ENDPOINT_GET_LOAN_OFFERS),
        ])

        return {
          ifpApplicationsMetadata,
          loanApplicationsMetadata,
          loanOffersMetadata,
        } satisfies ApplicationsMetaData
      }}
      heading={intl.formatMessage({ id: 'common-loading' })}
      onAbort={props.onAbort}
    />
  )
}
